/* eslint-disable */
// Zone availability (delivery_ranges.active / schedule_enabled / available_days).
// Shared by the company-zone editor (SettingsDeliveryZones.vue) and the location-zone
// editor (DeliveryMethods.vue). Same day structure as the delivery method schedule:
// [{ day: 'monday', open, open_from: 'HH:MM', open_to: 'HH:MM', intervals: [{ open_from, open_to }] }]

export const ZONE_DAY_NAMES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']

export function buildZoneAvailableDays (existing) {
  const source = Array.isArray(existing) ? existing : []
  return ZONE_DAY_NAMES.map(function (name) {
    const found = source.find(function (d) { return d && d.day === name })
    if (found) {
      return {
        day: name,
        open: !!found.open,
        open_from: found.open_from || '',
        open_to: found.open_to || '',
        intervals: Array.isArray(found.intervals) ? found.intervals.map(function (iv) { return { open_from: iv.open_from || '', open_to: iv.open_to || '' } }) : []
      }
    }
    // nothing saved yet -> every day open 08:00 - 22:00 (like the method schedule)
    return { day: name, open: !source.length, open_from: '08:00', open_to: '22:00', intervals: [] }
  })
}

// Make sure the zone object carries the 3 fields (reactively), keeping saved values.
// New zones: active, schedule off.
export function ensureZoneAvailability (vm, zone) {
  if (!zone) return
  vm.$set(zone, 'active', zone.active === undefined || zone.active === null ? true : !!zone.active)
  vm.$set(zone, 'schedule_enabled', !!zone.schedule_enabled)
  vm.$set(zone, 'available_days', buildZoneAvailableDays(zone.available_days))
}

function toMinutes (time) {
  if (!time || typeof time !== 'string') return null
  const m = time.match(/^(\d{1,2}):(\d{2})/)
  if (!m) return null
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10)
}

// All intervals of a day: key 0 = the main open_from/open_to, key i + 1 = intervals[i].
function dayPairs (day) {
  const pairs = [{ key: 0, from: day.open_from, to: day.open_to }]
  ;(day.intervals || []).forEach(function (iv, i) {
    pairs.push({ key: i + 1, from: iv.open_from, to: iv.open_to })
  })
  return pairs
}

// Keys (see dayPairs) of the intervals that overlap another interval of the same day.
// Touching intervals (08:00-09:00 + 09:00-10:00) are fine.
export function overlappingIntervalKeys (day) {
  const valid = dayPairs(day)
    .map(function (p) { return { key: p.key, from: toMinutes(p.from), to: toMinutes(p.to) } })
    .filter(function (p) { return p.from !== null && p.to !== null && p.from < p.to })
    .sort(function (a, b) { return a.from - b.from })
  const keys = {}
  for (let i = 1; i < valid.length; i++) {
    for (let j = 0; j < i; j++) {
      if (valid[i].from < valid[j].to) {
        keys[valid[i].key] = true
        keys[valid[j].key] = true
      }
    }
  }
  return keys
}

export function intervalPairInvalid (from, to) {
  const f = toMinutes(from)
  const t = toMinutes(to)
  return f === null || t === null || f >= t
}

// First validation error message ('' when valid). Only checked when the schedule is on.
export function zoneAvailabilityError (zone, t) {
  if (!zone || !zone.schedule_enabled) return ''
  const days = zone.available_days || []
  let hasOpenDay = false
  for (let i = 0; i < days.length; i++) {
    const day = days[i]
    if (!day.open) continue
    hasOpenDay = true
    const pairs = dayPairs(day)
    for (let j = 0; j < pairs.length; j++) {
      if (!pairs[j].from || !pairs[j].to) return t('zoneAvailability.hoursRequired')
      if (intervalPairInvalid(pairs[j].from, pairs[j].to)) return t('zoneAvailability.hoursOrder')
    }
    if (Object.keys(overlappingIntervalKeys(day)).length) {
      return t('zoneAvailability.overlap') + ' (' + t('days.' + day.day) + ')'
    }
  }
  if (!hasOpenDay) return t('zoneAvailability.noOpenDay')
  return ''
}

// Fields to send to the API on save.
export function zoneAvailabilityPayload (zone) {
  return {
    active: zone.active === undefined || zone.active === null ? true : !!zone.active,
    schedule_enabled: !!zone.schedule_enabled,
    available_days: Array.isArray(zone.available_days) ? zone.available_days : null
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Settings/DeliveryPreferences/zoneAvailability.js